// @generated by protoc-gen-es v2.14.1 with parameter "target=ts"
// @generated from file login.proto (package sextante.seguridad.login.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { CultivoResumen } from "./terceros_lote_pb";
import { file_terceros_lote } from "./terceros_lote_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file login.proto.
 */
export const file_login: GenFile = /*@__PURE__*/
  fileDesc("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", [file_terceros_lote]);

/**
 * Credenciales de una cuenta de la app Cliente; en Nitrofert, email del cliente y contrasena global.
 *
 * @generated from message sextante.seguridad.login.v1.LoginAuthWebRequest
 */
export type LoginAuthWebRequest = Message<"sextante.seguridad.login.v1.LoginAuthWebRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message sextante.seguridad.login.v1.LoginAuthWebRequest.
 * Use `create(LoginAuthWebRequestSchema)` to create a new message.
 */
export const LoginAuthWebRequestSchema: GenMessage<LoginAuthWebRequest> = /*@__PURE__*/
  messageDesc(file_login, 0);

/**
 * Token de sesion que la app tiene guardado.
 *
 * @generated from message sextante.seguridad.login.v1.CheckTokenAuthWebRequest
 */
export type CheckTokenAuthWebRequest = Message<"sextante.seguridad.login.v1.CheckTokenAuthWebRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message sextante.seguridad.login.v1.CheckTokenAuthWebRequest.
 * Use `create(CheckTokenAuthWebRequestSchema)` to create a new message.
 */
export const CheckTokenAuthWebRequestSchema: GenMessage<CheckTokenAuthWebRequest> = /*@__PURE__*/
  messageDesc(file_login, 1);

/**
 * Token JWT (RS256) que el portal de Nitria pone en la URL: /auth/verify-acount?token=...
 *
 * @generated from message sextante.seguridad.login.v1.LoginPortalRequest
 */
export type LoginPortalRequest = Message<"sextante.seguridad.login.v1.LoginPortalRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message sextante.seguridad.login.v1.LoginPortalRequest.
 * Use `create(LoginPortalRequestSchema)` to create a new message.
 */
export const LoginPortalRequestSchema: GenMessage<LoginPortalRequest> = /*@__PURE__*/
  messageDesc(file_login, 2);

/**
 * Solo los campos que la app Cliente realmente lee (ver mapGrpcLoginResponse.ts
 * y sus usos): a diferencia de Dto.Seguridad.Response.LoginAuthWebResponse (el
 * DTO de REST), no lleva id/isEliminado/ultimaActualizacion -son la convencion
 * generica de BaseResponse del lado servidor, el cliente ni los tipa- ni
 * has_usuarios/fechaVencimientoPlataforma -se declaraban en el tipo TS pero
 * no los lee nada-. Guid viaja como string (proto no tiene tipo nativo).
 * 
 * Decision del 2026-09-08: el login trae tambien fincas + lotes del cliente
 * (campo "fincas" abajo), en vez de que el cliente pida esa lista aparte. Es
 * una decision consciente, no el default recomendado -ver CLAUDE.md, seccion
 * migracion a gRPC-Web, para el analisis de costos (payload en cada
 * checkToken, que corre en cada carga de pagina)-, tomada porque el cliente
 * va a guardar este resultado en una base local nueva y propia (no la
 * IndexedDB/sync delta que ya usa REST), sin tocar lo existente.
 *
 * @generated from message sextante.seguridad.login.v1.LoginAuthWebResponse
 */
export type LoginAuthWebResponse = Message<"sextante.seguridad.login.v1.LoginAuthWebResponse"> & {
  /**
   * Token de sesion: la app lo manda en el header token de cada pedido.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * Nombre a mostrar: el de la cuenta, o el del cliente si entro por el portal.
   *
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * @generated from field: string cliente_id = 3;
   */
  clienteId: string;

  /**
   * Hectareas que permite la licencia del cliente.
   *
   * @generated from field: int32 maximo_hectareas = 4;
   */
  maximoHectareas: number;

  /**
   * true si el cliente tiene una licencia de demostracion.
   *
   * @generated from field: bool is_demo_plataforma = 5;
   */
  isDemoPlataforma: boolean;

  /**
   * Fincas del cliente con sus lotes.
   *
   * @generated from field: repeated sextante.seguridad.login.v1.Finca fincas = 6;
   */
  fincas: Finca[];

  /**
   * Vencimiento de la licencia (Unix ms): la app muestra el aviso desde 15 dias antes. Si ya vencio o no
   * hay licencia, el login ni llega a responder (ver LicenciaPlataforma en Constantes).
   *
   * @generated from field: optional int64 fecha_vencimiento_plataforma = 7;
   */
  fechaVencimientoPlataforma?: bigint | undefined;
};

/**
 * Describes the message sextante.seguridad.login.v1.LoginAuthWebResponse.
 * Use `create(LoginAuthWebResponseSchema)` to create a new message.
 */
export const LoginAuthWebResponseSchema: GenMessage<LoginAuthWebResponse> = /*@__PURE__*/
  messageDesc(file_login, 3);

/**
 * Antes (hasta 2026-09-12) subconjunto reducido de Dto.Terceros.Response.ClienteFincaBaseResponse
 * -dejaba afuera ortomosaico/conteo/defaults de ganaderia/ubicacion administrativa-, pensado solo
 * para listar/identificar la finca; ClienteAsideMenuRender pedia el resto por REST enseguida
 * despues del login. Se amplio a practicamente paridad total con ClienteFincaBaseResponse (ver
 * campos agregados mas abajo) para que ese REST ya no haga falta. ubicacion y
 * satelite_area_geografica siguen "optional" (no siempre hay geometria, ver el bug de finca
 * incompleta que motivo este trabajo).
 * 
 * Geometrias en WKB (bytes), no GeoJSON (string): el objetivo de este mensaje
 * es viajar en el login/checkToken -que corre en cada carga de pagina-, asi
 * que se prioriza el tamano de la respuesta. WKB estandar de OGC (ST_AsBinary,
 * sin SRID -ver PostgisFunctions.AsBinary-); el cliente lo decodifica con
 * @terraformer/wkb (wkbToGeoJSON) al mismo Point/Polygon que ya usa REST.
 *
 * @generated from message sextante.seguridad.login.v1.Finca
 */
export type Finca = Message<"sextante.seguridad.login.v1.Finca"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string nombre_finca = 2;
   */
  nombreFinca: string;

  /**
   * @generated from field: double hectareas_finca = 3;
   */
  hectareasFinca: number;

  /**
   * @generated from field: double hectareas_productivas = 4;
   */
  hectareasProductivas: number;

  /**
   * 0 = Agricultura, 1 = Ganaderia
   *
   * @generated from field: int32 tipo_finca = 5;
   */
  tipoFinca: number;

  /**
   * WKB Point
   *
   * @generated from field: optional bytes ubicacion = 6;
   */
  ubicacion?: Uint8Array | undefined;

  /**
   * WKB Polygon
   *
   * @generated from field: optional bytes satelite_area_geografica = 7;
   */
  sateliteAreaGeografica?: Uint8Array | undefined;

  /**
   * @generated from field: repeated sextante.seguridad.login.v1.Lote lotes = 8;
   */
  lotes: Lote[];

  /**
   * Cliente dueno de la finca.
   *
   * @generated from field: string cliente_id = 9;
   */
  clienteId: string;

  /**
   * @generated from field: optional string departamento_id = 10;
   */
  departamentoId?: string | undefined;

  /**
   * @generated from field: optional string departamento_nombre = 11;
   */
  departamentoNombre?: string | undefined;

  /**
   * @generated from field: optional string municipio_id = 12;
   */
  municipioId?: string | undefined;

  /**
   * @generated from field: optional string municipio_nombre = 13;
   */
  municipioNombre?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_id = 14;
   */
  departamentoRegionId?: string | undefined;

  /**
   * @generated from field: optional string departamento_region_nombre = 15;
   */
  departamentoRegionNombre?: string | undefined;

  /**
   * Ganancia de peso diaria esperada por animal, en gramos.
   *
   * @generated from field: double ganaderia_crecimiento_diario_gr = 16;
   */
  ganaderiaCrecimientoDiarioGr: number;

  /**
   * Dias que conviene dejar descansar un potrero.
   *
   * @generated from field: int32 ganaderia_dias_descanso_optimo = 17;
   */
  ganaderiaDiasDescansoOptimo: number;

  /**
   * Dias que conviene tener los animales en un potrero.
   *
   * @generated from field: int32 ganaderia_dias_ocupacion_optimo = 18;
   */
  ganaderiaDiasOcupacionOptimo: number;

  /**
   * Carga animal recomendada, en animales por hectarea.
   *
   * @generated from field: double ganaderia_animales_x_hectarea_optimo = 19;
   */
  ganaderiaAnimalesXHectareaOptimo: number;

  /**
   * Arboles que se revisan en cada monitoreo.
   *
   * @generated from field: int32 arboles_monitorear = 20;
   */
  arbolesMonitorear: number;

  /**
   * URL de los tiles del ortomosaico de la finca, si ya se proceso.
   *
   * @generated from field: optional string uri_ortomosaico = 21;
   */
  uriOrtomosaico?: string | undefined;

  /**
   * Plantilla de URL de los tiles del conteo de animales, si existe.
   *
   * @generated from field: optional string conteo_pre_render = 22;
   */
  conteoPreRender?: string | undefined;

  /**
   * Ultimo paso del registro de la finca que se completo. No dice si la finca esta completa: eso es tener
   * area y al menos un lote.
   *
   * @generated from field: int32 paso_registro_completado = 23;
   */
  pasoRegistroCompletado: number;
};

/**
 * Describes the message sextante.seguridad.login.v1.Finca.
 * Use `create(FincaSchema)` to create a new message.
 */
export const FincaSchema: GenMessage<Finca> = /*@__PURE__*/
  messageDesc(file_login, 4);

/**
 * Subconjunto de Dto.Terceros.Response.ClienteFincaLoteResponse: deja afuera
 * los campos operativos de pesaje de ganaderia (peso real/estimado, fechas de
 * ingreso/salida) -son datos del modulo de Pesaje, no algo que haga falta
 * para identificar/renderizar un lote recien logueado-. cultivo va como
 * id+nombre, no el catalogo completo: el catalogo de cultivos ya se
 * sincroniza aparte (syncAllCatalogsInBackground).
 *
 * @generated from message sextante.seguridad.login.v1.Lote
 */
export type Lote = Message<"sextante.seguridad.login.v1.Lote"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string finca_id = 2;
   */
  fincaId: string;

  /**
   * @generated from field: string nombre_lote = 3;
   */
  nombreLote: string;

  /**
   * @generated from field: double area_hectareas = 4;
   */
  areaHectareas: number;

  /**
   * Area del lote en cuadras.
   *
   * @generated from field: double area_cuadras = 5;
   */
  areaCuadras: number;

  /**
   * true si el lote cuenta para las hectareas productivas de la finca.
   *
   * @generated from field: bool is_area_productiva = 6;
   */
  isAreaProductiva: boolean;

  /**
   * WKB Polygon, siempre presente
   *
   * @generated from field: bytes area_geografica = 7;
   */
  areaGeografica: Uint8Array;

  /**
   * Antes campos planos (cultivo_id/cultivo_nombre); ahora reusa el mismo CultivoResumen que ya
   * usa terceros_lote.proto (id/nombre/is_monitoreo_cafe/cantidad_plagas) — mismo dato, misma
   * forma, en vez de dos representaciones distintas del cultivo de un lote dentro de la misma app.
   *
   * @generated from field: optional sextante.terceros.lote.v1.CultivoResumen cultivo = 8;
   */
  cultivo?: CultivoResumen | undefined;
};

/**
 * Describes the message sextante.seguridad.login.v1.Lote.
 * Use `create(LoteSchema)` to create a new message.
 */
export const LoteSchema: GenMessage<Lote> = /*@__PURE__*/
  messageDesc(file_login, 5);

/**
 * Inicio de sesion de la SPA Cliente. Logica propia del servicio gRPC, sin la capa vieja de servicios. La
 * sesion es un token JWT que vence a los 15 dias y no se renueva; el estado de la cuenta se revisa en
 * memoria en cada pedido. Estos rpc no requieren sesion.
 *
 * @generated from service sextante.seguridad.login.v1.LoginService
 */
export const LoginService: GenService<{
  /**
   * Entrada con email y contrasena de una cuenta de la app; en Nitrofert (pagina oculta), con el email del cliente
   * y la contrasena global. Devuelve un token de sesion nuevo, los datos del cliente y sus fincas con lotes.
   * Credenciales invalidas o licencia vencida: InvalidArgument con el motivo.
   *
   * @generated from rpc sextante.seguridad.login.v1.LoginService.LoginAuthWeb
   */
  loginAuthWeb: {
    methodKind: "unary";
    input: typeof LoginAuthWebRequestSchema;
    output: typeof LoginAuthWebResponseSchema;
  },
  /**
   * Valida la sesion guardada en cada carga de la app y devuelve los datos frescos con el mismo token. Sesion
   * vencida, revocada o de otro tipo: NotFound.
   *
   * @generated from rpc sextante.seguridad.login.v1.LoginService.CheckTokenAuthWeb
   */
  checkTokenAuthWeb: {
    methodKind: "unary";
    input: typeof CheckTokenAuthWebRequestSchema;
    output: typeof LoginAuthWebResponseSchema;
  },
  /**
   * SSO desde el portal de Nitria, solo en la compilacion Nitrofert (decidido 2026-09-30, ver
   * Constantes.PortalNitria): valida el token que el portal manda en /auth/verify-acount y abre sesion para
   * el CLIENTE con ese email, sin cuenta de la app ni contrasena. Mismo corte por licencia y misma respuesta
   * que LoginAuthWeb, con el nombre del cliente. Todo rechazo es InvalidArgument con el motivo para el usuario.
   *
   * @generated from rpc sextante.seguridad.login.v1.LoginService.LoginPortal
   */
  loginPortal: {
    methodKind: "unary";
    input: typeof LoginPortalRequestSchema;
    output: typeof LoginAuthWebResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_login, 0);

